import 'regenerator-runtime';
import pageLoader from './page-loader';

window.addEventListener('load',  pageLoader());
